import React, {Component} from "react";
import "./login.scss";
import {toast} from 'react-toastify';

import {AuthService} from "../../../services/auth-service";
import { PublicClientApplication,  InteractionStatus, InteractionRequiredAuthError} from "@azure/msal-browser";
import { msalConfig } from "../../../authConfig";
import { withMsal } from "@azure/msal-react";
import ClientSelector from "../accounts/client-selector"

const pca = new PublicClientApplication(msalConfig);

class LoginDomain extends Component {

    constructor(props) {
        super(props);
        this.authService = new AuthService();

        this.state = {
            email: "",
            password: "",
            authComplete : false,
            loginAttempted: false
        };
    }

    callLogin() {
        if (!this.state.loginAttempted) {
            const isAuthenticated = this.props.msalContext.accounts.length > 0;
            const msalInstance = this.props.msalContext.instance;
    
            if (!isAuthenticated && this.props.msalContext.inProgress === InteractionStatus.None) {
                msalInstance.loginPopup();
                this.setState({ loginAttempted: true });
            }
        }
    }
    
    componentDidMount() {
        this.callLogin();
    }

    componentDidUpdate(prevProps, prevState) {
        // Only attempt login if it hasn't been tried before
        if (!this.state.loginAttempted) {
            this.callLogin();
        }
    }
    
    render() {
        const isAuthenticated = this.props.msalContext.accounts.length > 0;

        if(isAuthenticated && !this.state.authComplete)
        {

            const account = pca.getAllAccounts()[0];

            const accessTokenRequest = {
                scopes: ["user.read"],
                account: account
            }
            
            pca.acquireTokenSilent(accessTokenRequest).then(  (accessTokenResponse) => {
                // Acquire token silent success
                let accessToken = accessTokenResponse.accessToken;
                this.authService
                .authenticateDomainUser(accessTokenResponse.account.username, accessToken)
                .then(  (res) =>
                    {
                        this.authService.cacheUserData(res)
            
                        this.setState(
                            {
                                authComplete : true
                            });

                            
                    })
                //.then(this.notifyParent)
                .catch((error) => {
                    toast.error(error.message, {
                        position: toast.POSITION.TOP_RIGHT
                    });
                });
                // Call your API with token
                //callApi(accessToken);
            }).catch(function (error) {
                //Acquire token silent failure, and send an interactive request
                if (error instanceof InteractionRequiredAuthError) {
                pca.acquireTokenPopup(accessTokenRequest).then(function(accessTokenResponse) {
                    // Acquire token interactive success
                    let accessToken = accessTokenResponse.accessToken;


                    this.authService
                    .authenticateDomainUser(accessTokenResponse.account.username, accessToken)
                    .then(  (res) =>
                        {
                            this.authService.cacheUserData(res)
                
                            this.setState(
                                {
                                    authComplete : true
                                });
    
                                
                        })
                    //.then(this.notifyParent)
                    .catch((error) => {
                        toast.error(error.message, {
                            position: toast.POSITION.TOP_RIGHT
                        });
                    });
                   
                    // Call your API with token
                    //callApi(accessToken);
                }).catch(function(error) {
                    // Acquire token interactive failure
                    console.log(error);
                });
              }
                console.log(error);
            });
    }

        if (this.state.authComplete) {
            return <ClientSelector></ClientSelector> 
            
        } else {
            return <span>Authentication in progress</span>;
        }
    }
}

export default  withMsal(LoginDomain);
